module.exports = __webpack_public_path__ + "media/fonts/superstudio-regular-034e018480e8c064e4950edf7a9da71d.woff";